<template>
  <div class="search">
    <BreadsCrums :page="title" previous="home" />
    <div v-if="!error">
      <Articles
        v-if="!loading"
        :articles="articles"
        :pagination="pagination"
        :searchResults="searchResults"
        type="news"
        paginationType="search"
        :categoryId="categoryId"
      />
      <Loader v-else />
    </div>

    <div v-if="error">
      <div class="container" style="min-height:500px;">
        <div
          class="alert alert-danger text-center"
          style="margin-top:100px; font-size:20px"
          role="alert"
        >{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import APPURL from "../constant";
export default {
  watch: {
    $route() {
      this.getArticles();
      this.getLang();
    }
  },
  created() {
    document.title =
      this.$i18n.t("navBar.search") + this.$route.path.split("/")[3];
  },
  mounted() {
    this.getArticles();
    this.getLang();
  },
  computed: {
    aboutUs() {
      if (this.info[0]) {
        if (this.info[0].aboutFr) {
          return this.info[0].aboutFr;
        } else {
          return this.info[0].aboutUs;
        }
      }
      return "";
    }
  },
  data() {
    return {
      articles: {},
      title: "",
      pagination: {},
      categoryId: "",
      loading: true,
      error: false,
      errorMessage: "",
      locale: ""
    };
  },
  methods: {
    // getNextArticles() {
    //   this.getArticles(this.posts.next_page_url);
    // },
    getLang() {
      this.locale = this.$i18n.locale;
    },
    getArticles() {
      this.title = "search";
      this.searchResults =
        this.$i18n.t("navBar.allArticlesIncategory") +
        ' "' +
        this.$route.path.split("/")[3] +
        ' "';
      let link =
        APPURL.LINK + "category-by-name/" + this.$route.path.split("/")[3];
      Axios.get(link)
        .then(response => {
          if (response.data.data.results[0]) {
            this.categoryId = response.data.data.results[0].id;
            this.$root.categoryId = response.data.data.results[0].id;
          }
          let url =
            APPURL.LINK +
            "articles-by-category/" +
            this.$i18n.locale +
            "/" +
            this.categoryId +
            "/1/9";
          Axios.get(url)
            .then(response => {
              this.loading = false;
              this.articles = response.data.data.results.posts;
              this.pagination = response.data.data.pagination;
            })
            .catch(error => {
              this.loading = false;
              this.error = true;
              this.errorMessage = this.$i18n.t("subscribeError");
              return error;
              //console.log(error);
            });
        })
        .catch(error => {
          this.loading = false;
          this.error = true;
          this.errorMessage = this.$i18n.t("subscribeError");
          return error;
          //console.log(error);
        });

      //console.log("this.categoryId is ", this.$root.categoryId);
    }
  },
  name: "Search",
  components: {}
};
</script>

<style></style>
